/**
 * GlobalShortcuts — mounts the app-wide hotkeys and drives them with real
 * actions. Renders nothing; the registrations live in `lib/hotkeys`.
 *
 * Themes are intentionally NOT a global shortcut: theme switching is exposed
 * exclusively through the command palette's "Theme…" command.
 */

import { useNavigate } from "@tanstack/react-router";

import { useAppHotkeys } from "../../lib/hotkeys";
import {
  closeWorkspaceTab,
  getTerminalTabsState,
  setActiveWorkspace,
} from "../terminal/tabs-store";
import { openWidgetPicker } from "../terminal/widget-picker-store";
import { useCommandMenu } from "./command-menu";

export function GlobalShortcuts() {
  const { open, openWorkspacePicker } = useCommandMenu();
  const navigate = useNavigate();

  useAppHotkeys({
    openCommandMenu: open,
    // The backtick opens the add-widget picker for the active workspace.
    addWidget: openWidgetPicker,
    goToHome: () => navigate({ to: "/" }),
    goToBox: () => navigate({ to: "/box" }),
    goToApps: () => navigate({ to: "/apps" }),
    // Workspace-tab shortcuts (Mod+T / Mod+W with Alt/Option mirrors, plus
    // Mod+1…9 / Alt+1…9 to activate the Nth tab). `newTab` opens the same
    // global workspace picker the shell's `+` uses; `closeTab` closes the
    // active tab.
    newTab: openWorkspacePicker,
    closeTab: () => {
      const { activeId } = getTerminalTabsState();
      if (activeId) closeWorkspaceTab(activeId);
    },
    selectTab: (index) => {
      const { tabs } = getTerminalTabsState();
      const tab = tabs[index];
      if (tab) setActiveWorkspace(tab.id);
    },
  });

  return null;
}
